import React from 'react';
import {
  BaseButton,
  Gap,
  Icon,
  Text,
  ButtonGroup,
  Flex,
} from '@common/components';
import { Colors } from 'works/legacy/lib/style-helper';

type Props = {
  selectedCount: number;
  totalCount: number;
  onDeactivate: () => void;
  onMove: () => void;
  onCancel: () => void;
};

export function AdminWorkforceGroupStaffTableBatchActions({
  selectedCount,
  totalCount,
  onDeactivate,
  onMove,
  onCancel,
}: Props) {
  return (
    <>
      <div className="admin-workforce-group-staff-table-batch-actions">
        <Flex justify="space-between" align="center" fullWidth>
          <div>
            <Gap size="lg" align="center">
              <Text weight="medium" size="md">
                {selectedCount}/{totalCount} staff selected
              </Text>
              <BaseButton type="link" onClick={onCancel}>
                Cancel
              </BaseButton>
            </Gap>
          </div>
          <ButtonGroup>
            <BaseButton size="large" onClick={onDeactivate}>
              <Text color="coral" weight="bold">
                Deactivate
              </Text>
            </BaseButton>
            <BaseButton
              onClick={onMove}
              size="large"
              icon={<Icon kind="solid" icon="arrowsRepeat" size="md" />}
            >
              Move
            </BaseButton>
          </ButtonGroup>
        </Flex>
      </div>
      <style jsx>{`
        .admin-workforce-group-staff-table-batch-actions {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 72px;
          padding: 8px 24px;
          background: ${Colors.elmHyperlight};
          border-radius: 8px;
          margin-bottom: 16px;
          border: none;
        }
      `}</style>
    </>
  );
}
